/**
 * Benchmark results — Floto Deep audit, automated pass only (AI judge off),
 * run 2026-10-14 from floto-chrome-x `bench/a11y` against public test sites
 * that publish an answer key of planted barriers. Re-run and update together
 * with checks.data.ts.
 *
 * Honesty rules for anything rendered from this file: these are the
 * automated pass's numbers *before* expert review; some of these sites were
 * used while developing the checks (the harness calls them its "tuning set");
 * and "found" means a finding matched a documented WCAG A/AA barrier.
 */

export interface BenchmarkSite {
  name: string;
  publisher: string;
  url: string;
  found: number;
  total: number;
}

export const BENCHMARK_RUN_DATE = '2026-10-14';

export const BENCHMARK_SITES: BenchmarkSite[] = [
  {
    found: 20,
    name: 'Accessible University (inaccessible version)',
    publisher: 'University of Washington',
    total: 21,
    url: 'https://projects.accesscomputing.uw.edu/au/before.html',
  },
  {
    found: 18,
    name: 'Accessible University, modernised',
    publisher: 'Duke University',
    total: 19,
    url: 'https://openassessittoolkit.github.io/accessible_u/before_u.html',
  },
  {
    found: 39,
    name: 'Mars Commuter demo',
    publisher: 'Deque University',
    total: 46,
    url: 'https://dequeuniversity.com/demo/mars/',
  },
  {
    found: 79,
    name: 'Accessibility tool audit — test cases',
    publisher: 'GOV.UK (Government Digital Service)',
    total: 91,
    url: 'https://alphagov.github.io/accessibility-tool-audit/test-cases.html',
  },
  {
    found: 7,
    name: 'Accessibility tool audit — single-issue pages',
    publisher: 'GOV.UK (Government Digital Service)',
    total: 10,
    url: 'https://alphagov.github.io/accessibility-tool-audit/',
  },
  {
    found: 10,
    name: 'WCAG criteria no public demo covers',
    publisher: 'Floto test fixture',
    total: 10,
    url: '',
  },
];

export const BENCHMARK_TOTAL = BENCHMARK_SITES.reduce(
  (acc, s) => ({ found: acc.found + s.found, total: acc.total + s.total }),
  { found: 0, total: 0 },
);

export const BENCHMARK_PERCENT = Math.round(
  (BENCHMARK_TOTAL.found / BENCHMARK_TOTAL.total) * 100,
);
